import {
  Box,
  FormControlLabel,
  FormHelperText,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
} from '@mui/material';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEntityPermission } from '../../providers/EntityPermissionProvider/index';
import ReadOnly from './ReadOnly';

const Radio = forwardRef(
  (
    { overwriteProps = {}, ...props },
    ref,
    // eslint-disable-next-line arrow-body-style
  ) => {
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.name}>{currentvalue ? 'Yes' : 'No'}</ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return <input type="hidden" name={props?.name} value={currentvalue} />;
    }
    return <MuiRadio ref={ref} {...props} {...overwriteProps} />;
  },
);

export const RadioGroup = forwardRef(
  (
    { overwriteProps = {}, ...props },
    ref,
    // eslint-disable-next-line arrow-body-style
  ) => {
    const { helperText, error, ...restProps } = props;

    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return <ReadOnly name={props?.name}>{currentvalue?.label}</ReadOnly>;
    }

    if (isHidden(props?.permission)) {
      return (
        <input type="hidden" name={props?.name} value={currentvalue?.label} />
      );
    }

    return (
      <Box>
        <MuiRadioGroup ref={ref} row {...restProps} {...overwriteProps}>
          {props?.options?.map(option => {
            return (
              <FormControlLabel
                key={option?.label}
                value={option?.value}
                control={<Radio />}
                label={option.label}
              />
            );
          })}
        </MuiRadioGroup>
        {error || helperText ? (
          <FormHelperText sx={{ typography: 'body2' }} error={Boolean(error)}>
            {error || helperText}
          </FormHelperText>
        ) : null}
      </Box>
    );
  },
);

export default Radio;
